import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MobilitydashbordComponent } from './components/mobilitydashbord/mobilitydashbord.component';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ScrollingModule } from '@angular/cdk/scrolling';

import { DashbordComponent } from './components/dashbord/dashbord.component';
import { EditComponent } from './components/edit/edit.component';
import { AddclientComponent } from './components/addclient/addclient.component';
import { StringcheckComponent } from './components/stringcheck/stringcheck.component';
import { ObjectKeysPipe } from './Pipes/object-keys.pipe';
import { ObjectValuesPipe } from './Pipes/object-values.pipe';
import { ButtonComponent } from './components/button/button.component';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [
    AppComponent,
    MobilitydashbordComponent,
    DashbordComponent,
    EditComponent,
    AddclientComponent,
    StringcheckComponent,
    ObjectKeysPipe,
    ObjectValuesPipe,
    ButtonComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    ScrollingModule,
    CommonModule,
  ],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule {}
